export const DASHBOARD_QUICK_ENTRY_COPY = {
  ariaLabel: 'Open quick log',
  title: 'Add care note',
  subtitle: 'Speak or type a care moment. Lifelog organizes the details into the timeline.',
  quickActionLabel: 'Add care note',
  importActionLabel: 'Import past records',
  dataCy: 'dashboard-quick-entry',
  actionKey: 'quick_note',
};
